import { RootState } from "@src/store";
import { ITakeOffToEnRouteInitialState } from "./types";
import { createSelector } from "@reduxjs/toolkit";

const TakeOffToEnRoutePageReducer = (state: RootState): ITakeOffToEnRouteInitialState => state.TakeOffToEnRoutePageReducer;
const TakeOffToEnRoutePageState = createSelector([TakeOffToEnRoutePageReducer], (state) => state);

export const selectSerialNumber = createSelector([TakeOffToEnRoutePageState], (state) => state.serialNumber);
export const selectManualControl = createSelector([TakeOffToEnRoutePageState], (state) => state.isManualControl);
